var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordmark114(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 114,
    height: 23.3374,
    viewBox: "0 0 114 23.3374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_0_25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 11.3833C0 4.59156 5.2074 0 12.3825 0C18.4778 0 23.2727 3.48995 23.9717 8.6308L17.7505 9.27416C17.2436 6.94955 15.0838 5.26527 12.5746 5.26527C9.08304 5.26527 6.69972 7.71431 6.69972 11.3863C6.73121 15.0584 9.11137 17.5074 12.5399 17.5074C15.0177 17.5074 17.2405 15.8565 17.7788 13.5592L24 14.2633C23.4301 19.3434 18.6037 22.8 12.3794 22.8C5.2074 22.8 0 18.1781 0 11.3833Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.8 22.8L29.9147 -6.10352e-06H39.7166L46.8 22.8H39.9393L38.8638 19.3295H30.7362L29.6607 22.8H22.8ZM32.0657 14.5547H37.5687L34.9756 5.70315H34.6589L32.0657 14.5547Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M73.2 22.8V-6.10352e-06H79.6533V9.10736H87.1467V-6.10352e-06H93.6V22.8H87.1467V13.8916H79.6533V22.8H73.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M96 22.8V-6.10352e-06H113.679V5.28631H102.545V9.10736H113.068V13.4684H102.545V17.5137H114V22.8H96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M63.6 5.36946C63.6 4.56092 63.9492 3.86291 64.6545 3.27833C65.3564 2.69374 66.1909 2.39999 67.1616 2.39999C68.1323 2.39999 69.0402 2.69374 69.7455 3.27833C70.4473 3.86291 70.8 4.56092 70.8 5.36946C70.8 6.2187 70.4473 6.93417 69.7455 7.52166C69.0436 8.10625 68.1812 8.39999 67.1616 8.39999C66.142 8.39999 65.3529 8.10625 64.6545 7.52166C63.9492 6.93708 63.6 6.2187 63.6 5.36946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M58.8 22.8C52.1831 22.8 46.8 17.6861 46.8 11.4C46.8 5.1139 52.1831 -6.10352e-06 58.8 -6.10352e-06V6.02189C55.6769 6.02189 53.1388 8.43612 53.1388 11.4C53.1388 14.3639 55.6801 16.7781 58.8 16.7781C61.9199 16.7781 64.4612 14.3669 64.4612 11.4H70.8C70.8 17.6861 65.4169 22.8 58.8 22.8Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 23.3374,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordmark114);
export default __webpack_public_path__ + "static/media/wordmark-114.21ca6f6fd76254a18bb610ae308c23fe.svg";
export { ForwardRef as ReactComponent };